import React, {useMemo} from 'react'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {SnackbarProvider} from 'notistack'
import {Column} from 'react-table'

const TableCostsWrapper = ({arrayDates, data, loading}: any) => {
  const columns: Column<any>[] = useMemo(() => {
    const baseColumns: Column<any>[] = [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de Operación' />,
        accessor: 'tipoOperacion',
      },
    ]
    const rangeColumns: Column<any>[] = arrayDates.map((item, index) => {
      const splitDate = item.fecha.split('-')
      const formatDate = splitDate[2] + '/' + splitDate[1] + '/' + splitDate[0]
      return {
        Header: (props) => <KTableHeader tableProps={props} title={formatDate} />,
        accessor: `${item.id}`,
      }
    })

    const lasColumn: Column<any>[] = [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cant. Prom Diario' />,
        accessor: 'cantidadPromedio',
      },
    ]
    return [...baseColumns, ...rangeColumns, ...lasColumn]
  }, [data, arrayDates])

  return (
    <KTCard shadow className='m-5'>
      <KTable data={data} columns={columns as any} showPagination={false} showButtons={false} />
      {loading ? <KTableLoading title='Cargando...' /> : null}
      <SnackbarProvider />
    </KTCard>
  )
}

export {TableCostsWrapper}
